function Github() {
    return (
        <div className="row">
            <a href="https://github.com/joelpeyton">
                <i className="bi bi-github p-1" style={{float: "right"}}></i>
            </a> 
        </div>
    );
}

export default Github;
